/** True when an outside-interaction target is still a portaled Radix/cmdk surface (popover, select, menu, command). */
export function interaction_target_is_inside_radix_portal(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null | undefined
  if (!el || typeof el.closest !== "function") {
    return false
  }
  return Boolean(
    el.closest("[data-radix-popper-content-wrapper]") ||
      el.closest("[data-radix-select-content]") ||
      el.closest("[data-radix-dropdown-menu-content]") ||
      el.closest("[role='listbox']") ||
      el.closest("[cmdk-list]") ||
      el.closest("[cmdk-input]") ||
      el.closest("[cmdk-item]")
  )
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("interaction_target_is_inside_radix_portal", () => {
    it("returns false for null and non-element targets", () => {
      expect(interaction_target_is_inside_radix_portal(null)).toBe(false)
      expect(interaction_target_is_inside_radix_portal({} as EventTarget)).toBe(false)
    })

    it("returns true when target is inside a radix popper wrapper", () => {
      const wrapper = document.createElement("div")
      wrapper.setAttribute("data-radix-popper-content-wrapper", "")
      const inner = document.createElement("button")
      wrapper.appendChild(inner)
      document.body.appendChild(wrapper)
      try {
        expect(interaction_target_is_inside_radix_portal(inner)).toBe(true)
      } finally {
        document.body.removeChild(wrapper)
      }
    })

    it("returns true when target is radix select content", () => {
      const content = document.createElement("div")
      content.setAttribute("data-radix-select-content", "")
      document.body.appendChild(content)
      try {
        expect(interaction_target_is_inside_radix_portal(content)).toBe(true)
      } finally {
        document.body.removeChild(content)
      }
    })

    it("returns false for plain body clicks", () => {
      expect(interaction_target_is_inside_radix_portal(document.body)).toBe(false)
    })
  })
}
